<template>
  <md-content class="md-scrollbar">
    <div class="spent-display" :class="[{ 'not-found-layout': history.transactions.length === 0 }]">
      <div v-for="(spent, index) in history.transactions" :key="index">
        <div class="spent-container">
          <div class="img">
            <router-link :to="`/s-app/item-details/${spent.ItemID}`" v-if="spent.Partner_id !== 0 && spent.ItemID !== undefined">
              <img
                :src="getItemImagePath({ id: spent.ItemID })"
                alt="product"
                width="40px"
                height="40px"
              />
            </router-link>
            <img
              src="/img/swampum-polygon.png"
              class="item-img"
              alt="product"
              v-else
              width="40px"
              height="40px"
            />
          </div>
          <div class="spent-content">
              <div class="spent-title" v-html="_formatTitle(spent)" />
              <div class="spent-note" v-html="_formatNote(spent)" />
          </div>
          <div class="amount">
            <h5 class="spent-amount" v-html="formatPoints(spent.Amount)" />
            <img
              class="ml-1 mb-4"
              src="/img/Polygon_7.svg"
              alt="Swampum"
              width="12"
              height="12"
            />
          </div>
        </div>
        <hr />
      </div>
      <div class="not-found" v-if="history.transactions.length === 0">
        <span>No spent transactions were found in your history</span>
        <hr />
      </div>
    </div>
  </md-content>
</template>

<script>
import itemType from "@/enum/item-type";
import moment from "moment";
import UserHelperVue from "@/mixins/UserHelper.vue";
import PointsHelperVue from "@/mixins/PointsHelper.vue";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
export default {
  name: "PointsSpent",
  mixins: [UserHelperVue, PointsHelperVue, ItemHelperVue],
  props: ["history"],
  methods: {
    _formatTitle(spent) {
      if (spent !== undefined) {
        return this.getTradeTitle(spent);
      }
    },
    _formatNote(spent) {
      if (spent !== undefined) {
        const note = this.getTradeNote(spent);
        if (note !== undefined) {
          return `<span class="user-name-content">${note}</span> — <span>${this._formatDate(spent.Date)}</span>`;
        }
        return `<span>ITEM — ${this._formatDate(spent.Date)}</span>`;
      }
      return "ITEM";
    },
    _formatDate(date) {
      return moment(new Date(date)).format("MM/DD/YYYY");
    },
    getTradeNote(spent) {
      if (spent.ItemID) {
        const item = this.getItem(spent);
        if (item !== undefined) {
          const tradeType = this.getTradeType(item);
          switch (tradeType) {
            case "lend":
              return `<a class="user-name" href="/s-app/profile-page/${spent.Partner_id}">${spent.Partner}</a> lent to you`;
            case "borrow":
              return `You borrow from <a class="user-name" href="/s-app/profile-page/${spent.Partner_id}">${spent.Partner}</a>`;
            case "sell":
              return `<a class="user-name" href="/s-app/profile-page/${spent.Partner_id}">${spent.Partner}</a> sold to you`;
            case "buy":
              return `You bought from <a class="user-name" href="/s-app/profile-page/${spent.Partner_id}">${spent.Partner}</a>`;
          }
        }
      }
    },
    getItem(spent) {
      let item;
      this.history.items.forEach((i) => {
        if (i.id === spent.ItemID) {
          item = i;
        }
      });

      return item;
    },
    getTradeTitle(spent) {
      const item = this.getItem(spent);
      if (item !== undefined) {
        return `ITEM (<a class="item-spent-name" href="${this.getItemLink(item)}">${item.title}</a>) — ${this.getTradeType(item)} type`;
      }
      if (spent.Note.includes("send"))
        return `<div class="item-earned-content">
                  <span class="">Points send directly to user</span>
                  <a class="item-earned-name" href="${this.getPartnerLink(spent)}">${spent.Partner}</a>
                </div>`;
      return spent.Note;
    },
    getItemLink(item) {
      return `/s-app/item-details/${item.id}`;
    },
    getPartnerLink(item) {
      return `/s-app/profile-page/${item.Partner_id}`;
    },
    getTradeType(item) {
      if (item.type === itemType.GIVE) return "sell";
      if (item.type === itemType.RECEIVE) return "buy";
      if (item.type === itemType.BORROW) return "borrow";
      if (item.type === itemType.LEND) return "lend";
    },
  },
};
</script>

<style lang="scss" scoped>
.img img {
  max-width: unset;
}
.spent-display {
  display: flex;
  flex-direction: column;
}

.spent-content {
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 5px
}
.spent-container {
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px
}
.item-img {
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.35));
}
.amount {
  display: flex;
  margin-right: 10px;
}
.spent-amount {
  margin: 0;
  color: $primary;
}
.not-found {
  margin-top: 2rem;
  color: $black;
  font-weight: 500;
  align-self: center;
}
.not-found-layout {
  justify-content: center;
}
</style>

<style lang="scss">
.spent-title,
.item-spent-name,
.user-name {
  font-weight: 500;
}
.item-spent-name {
  color: $primary !important;
}
.user-name {
  color: $primary !important;
}
.spent-note {
  color: #616161;
}
.spent-title {
  color: $black;
}
.user-name-content {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 300px;
}
/* .span-content {
  display: inline-flex;
  flex-wrap: nowrap;
} */
</style>

<style lang="scss" scoped>
.md-content {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}
@media (max-width: 374px) {
  .md-content { overflow-x: auto; }
}
/* .item-spent-content {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width:300px;
} */
</style>
